import React, {useEffect, useState} from "react";
import {Form, Formik} from "formik";
import InputField from "../../components/InputField";
import FormikSelectField from "../../components/FormikSelectField";
import FormSectionArray from "../../components/FormSectionArray";
import {useGetRoles} from "../../hooks/roles/useGet";
import {useGetFormCategories} from "../../hooks/formCategories/useGet";
import {useUpdateForm} from "../../hooks/forms/useUpdate";
import SubmitButton from "../../components/SubmitButton";
import {Error, Success} from '../../components/Status'
import {formInitialValues, formValidationSchema, updateformValidationSchema} from "../../utils";
import {useGetFormType} from "../../hooks/forms/useGet";


const EditForm = ({id}) => {


    const {data: formType, isLoading, isError} = useGetFormType(id)

    const {data: roles, isSuccess: gotRoles} = useGetRoles()
    const {data: categories, isSuccess: gotCategories} = useGetFormCategories()

    const [error, setError] = useState("")
    const [success, setSuccess] = useState("")

    const {mutate: updateForm, error: updateError, isLoading: editLoading, isSuccess} = useUpdateForm(id)


    const roleOptions = gotRoles && roles?.map((item) => ({name: item.roleName, value: item.roleId}))
    const categoryOptions = gotRoles && categories?.map((item) => ({name: item.categoryName, value: item.categoryId}))

    const onSubmit = (values) => {
        if (values.formSections?.length === 0) {
            setError('Please add at least one section');
            return
        }


        updateForm(values)
    };


    // EFFECTS
    useEffect(() => {
        if (isSuccess) {
            setSuccess("Form updated successfully")
            setTimeout(() => {
                window.location.reload()
            }, 2000);
        }
    }, [isSuccess])

    useEffect(() => {
        if (updateError) {
            const message = updateError?.response?.data?.message
            setError(message)
        }
    }, [updateError])

    if (isLoading) return <span>Loading...</span>
    if (isError) return <span>Oops something happened....</span>

    return (
        <Formik
            initialValues={formType ?? formInitialValues}
            validationSchema={updateformValidationSchema}
            onSubmit={onSubmit}
            validateOnChange={false}
            validateOnBlur={false}
            
        >
            {(formik) => (
                <Form className="w-full lg:w-[60vw] flex flex-col space-y-5 my-5">
                    {success.length > 0 && <Success>{success}</Success>}
                    {error.length > 0 && <Error>{error}</Error>}
                    <br/>

                    <br/>
                    <div className="grid lg:grid-cols-2 gap-4">
                        <InputField
                            name="formTypeName"
                            id="formTypeName"
                            placeholder="Name"
                            label="Name"
                            required
                        />
                        {gotRoles && <FormikSelectField
                            name="initialDesk"
                            id="initialDesk"
                            label="Initial Desk"
                            defaultValue={formik.values["initialDesk"]}
                            required
                            options={roleOptions}
                        />}
                        {gotCategories && <FormikSelectField
                            name="categoryId"
                            id="categoryId"
                            label="Category"
                            required
                            defaultValue={formik.values["categoryId"]}
                            options={categoryOptions}
                        />}
                        <InputField
                            name="description"
                            id="description"
                            placeholder="Description"
                            label="Description"
                            rows="4"
                            cols="50"
                            as='textarea'
                        />
                        <InputField
                            name="activeStatus"
                            id="activeStatus"
                            type="checkbox"
                            label="Status"
                        />
                    </div>

                    <FormSectionArray/>
                    <div className="w-full flex justify-between my-10">
                        <button
                            type="reset"
                            className="h-10 w-24 text-white  bg-gray-600 transition-all ease-in-out"
                        >
                            Cancel
                        </button>
                        <div
                            type="submit"
                            className="h-10 w-24 text-white  bg-[#dd4f04] transition-all ease-in-out flex justify-center items-center"
                        >
                            <SubmitButton loading={editLoading}>Update</SubmitButton>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default EditForm;



